// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-table-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 50vh;
  overflow-y: auto;
}
.schedule-table-container::-webkit-scrollbar {
  width: 10px;
}
.schedule-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.schedule-table-container::-webkit-scrollbar-thumb {
  background: #888;
}
.schedule-table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
@media (max-height: 824px) {
  .schedule-table-container {
    max-height: 25vh;
  }
}
@media (max-height: 568px) {
  .schedule-table-container {
    max-height: 25vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/schedule/Schedule.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".schedule-table-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  height: 50vh;\n  overflow-y: auto;\n}\n.schedule-table-container::-webkit-scrollbar {\n  width: 10px;\n}\n.schedule-table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n.schedule-table-container::-webkit-scrollbar-thumb {\n  background: #888;\n}\n.schedule-table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n@media (max-height: 824px) {\n  .schedule-table-container {\n    max-height: 25vh;\n  }\n}\n@media (max-height: 568px) {\n  .schedule-table-container {\n    max-height: 25vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
